import type {Props as OverlayProps} from '@/components/PictureGalleryMosaicOverlay/components/Overlay';

import {Block} from '@travel-frontend/ui-components';

import {ImageGalleryMosaic} from '@/components/ImageGalleryMosaic';
import {Overlay} from '@/components/PictureGalleryMosaicOverlay/components/Overlay';

type Props = OverlayProps & {
  images: Array<string>;
};

export const PictureGalleryMosaicOverlay: React.FunctionComponent<Props> = ({
  images,
  ...restProps
}) => {
  return (
    <Overlay {...restProps}>
      <Block margin="-16px">
        <ImageGalleryMosaic images={images} />
      </Block>
    </Overlay>
  );
};
